import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MdCardModule } from '@angular/material';
import { SharedModule } from '../../shared/shared.module';
// import { AdministrationRoutingModule } from './administration.routing';
import { ActiveLinkComponent } from './active-link/active-link.component';

@NgModule({
    declarations: [
      ActiveLinkComponent
    ],
    imports: [
        SharedModule,
        MdCardModule
       // AdministrationRoutingModule
    ],
    providers: [],
    bootstrap: []
})
export class AdministrationModule {}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/administration/administration.module.ts